import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly KEY = 'centaiva-theme';
  private readonly _dark$ = new BehaviorSubject<boolean>(false);
  readonly isDark$ = this._dark$.asObservable();
  get isDark(): boolean { return this._dark$.value; }

  constructor() {
    const saved = localStorage.getItem(this.KEY);
    const preferDark = saved !== null ? saved === 'dark' : true;
    this.apply(preferDark);
  }

  toggle(): void { this.apply(!this._dark$.value); }

  private apply(dark: boolean): void {
    document.documentElement.classList.toggle('dark',   dark);
    document.documentElement.classList.toggle('p-dark', dark);
    localStorage.setItem(this.KEY, dark ? 'dark' : 'light');
    this._dark$.next(dark);
  }
}
